import './AnimatedContainer.scss';

import React from 'react';

interface Props {
  children: any;
}

export default (props: Props) => <div className="AnimatedContainer">{props.children}</div>;
